import React from 'react';
import './Spinner.scss';

export const Spinner = () => <div className="spinner" />;
